type NotificationProvider = "firestore" | "fcm";

export const getNotificationProvider = (): NotificationProvider => {
  const provider = process.env.REACT_APP_NOTIFICATION_SERVICE as NotificationProvider | undefined;
  return provider === "fcm" ? "fcm" : "firestore";
};

export const getEnvironment = (): string => {
  return process.env.REACT_APP_ENVIRONMENT || "production";
};

export const isDevelopmentMode = (): boolean => {
  return getEnvironment() === "development" || getEnvironment() === "staging";
};

export const getApiUrl = (): string => {
  return (
    process.env.REACT_APP_CORLMI_API_URL ||
    "https://apig2-l6hslyohda-uc.a.run.app"
  );
};

export const getRecaptchaSiteKey = (): string | undefined => {
  return process.env.REACT_APP_RECAPTCHA_SITE_KEY;
};

export const getVapidKey = (): string | undefined => {
  return process.env.REACT_APP_VAPID_KEY;
};
